import { css } from "../../../styled-system/css";

export const styles = {
  paper: () =>
    css({
      paddingY: "baseUnit.mobile3",
      paddingX: "baseUnit.mobile5",
      marginBottom: "baseUnit.mobile10",
      borderRadius: "4px",
      boxShadow: "paperWrapper",
      tablet: {
        maxWidth: "paperWrapper.widthMobile",
        margin: "auto",
      },
      desktop: {
        maxWidth: "paperWrapper.widthDesktop",
        marginBottom: "baseUnit.mobile30",
      },
    }),
};
